import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import useUnlockPolicy from './useUnlockPolicy';

// this is a failsafe hook on the Layout in case their issues with legacy PBE and a policy doesn't get unlocked
const useCheckForLockedPolicies = (enabled?: boolean) => {
  const { lockedPolicyNumber, custKey, unlockPolicy } = useUnlockPolicy();
  const { pathname } = useLocation();
  const isEditPolicy = pathname.includes('edit');
  const shouldMakeLockCall: boolean =
    !!enabled && !!lockedPolicyNumber && !isEditPolicy && !!custKey;

  useEffect(() => {
    if (shouldMakeLockCall) {
      unlockPolicy();
    }
  }, [shouldMakeLockCall]);
};

export default useCheckForLockedPolicies;
